import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './shape.scss';

const Shape = ({ className, color="gradient_99" }) => (
  <svg className={classnames(styles.shape, styles[color])} viewBox="0 0 376 26" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 24.782C83.486 8.26 146.153 0 188 0c41.847 0 104.514 8.26 188 24.782V26H0v-1.218z" fillRule="evenodd" />
  </svg>
);

Shape.propTypes = {
  color: PropTypes.string,
};

export { Shape };


// WEBPACK FOOTER //
// ./src/elements/shape/shape.js